// extracted by mini-css-extract-plugin
export var button = "wt+nP";
export var content = "Fj1kE";
export var root = "nAt7J";
export var text = "QdRHB";